// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .warning-row {\n  background: oldlace;\n}\n.el-table .offline {\n  background: #fcbdbd;\n  /* color: #f0f9eb; */\n}\n.el-table .success-row {\n  background: #f0f9eb;\n}\n", ""]);
// Exports
module.exports = exports;
